import React from "react";
import { Box, Container } from "@mui/joy";
import s from "./Layout.module.scss";
import { Outlet } from "@tanstack/react-router";

const LayoutPage: React.FC = () => {
  return (
    <Container className={s.container} maxWidth={false}>
      <Box className={s.main}>
        <React.Suspense>
          <Outlet />
        </React.Suspense>
      </Box>
      {/* <Footer /> */}
      {/* TODO: footer? */}
    </Container>
  );
};

export default LayoutPage;
